var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "item" }, [
    _c(
      "div",
      { staticClass: "header", style: { marginTop: "20px" } },
      [
        _c("w-fa", {
          staticClass: "event-ico",
          class: _vm.event.ComputedProps.icon,
          attrs: { icon: _vm.event.ComputedProps.icon },
        }),
        _vm._v(_vm._s(_vm.event.ComputedProps.title) + " "),
      ],
      1
    ),
    _c("div", { staticClass: "header info" }, [
      _c("div", { staticClass: "user" }, [
        _vm._v(" " + _vm._s(_vm.event.Creator) + " "),
      ]),
      _c("div", { staticClass: "time" }, [
        _vm._v(" " + _vm._s(_vm.event.getTimeStampString()) + " "),
      ]),
    ]),
    _c("div", {
      directives: [
        {
          name: "safe-html",
          rawName: "v-safe-html",
          value: _vm.event.ComputedProps["message"] || "",
          expression: "event.ComputedProps['message'] || ''",
        },
      ],
      staticClass: "message",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }